import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';

const csClient = createClient('/rest/operator-api/charging-stations');
const poolsClient = createClient('/rest/operator-api/pools');

export interface InviteOwnerRequest {
  email: string;
}

export type InviteOwnerStatus = 'ASSIGNED' | 'ALREADY_HAS_ACCESS' | 'INVITED';

export interface InviteOwnerResultDto {
  status: InviteOwnerStatus;
  rootName: string | null;
}

export const inviteOwnerPermissions = {
  INVITE_CHARGING_STATION: 'cpms.invite-charging-station-owner',
  INVITE_POOL: 'cpms.invite-pool-owner'
};

export const inviteChargingStationOwner: SaveOperation<InviteOwnerRequest, InviteOwnerResultDto> = postRequestFactory<
  InviteOwnerRequest,
  InviteOwnerResultDto
>(csClient, {
  pattern: '/{chargingStationId}/invite-owner',
  permissionId: inviteOwnerPermissions.INVITE_CHARGING_STATION
});

export const inviteLocationOwner: SaveOperation<InviteOwnerRequest, InviteOwnerResultDto> = postRequestFactory<
  InviteOwnerRequest,
  InviteOwnerResultDto
>(poolsClient, {
  pattern: '/{poolId}/invite-owner',
  permissionId: inviteOwnerPermissions.INVITE_POOL
});
